export const environment = {
  production: false,
  api: {
    KEY: '',
    BASE_URL: "https://paas-api.seamfix.com",
    SEAMID_URL: "https://seamid-api.seamfix.com",
    BIOREGISTRA_URL: 'https://web.bioregistra.ng',
    EMAIL_TEMPLATE_BASE_URL: "https://sfx-seamid-prod.s3.us-east-2.amazonaws.com"
  },
  
  billable: {
    BILLABLE_JS: "https://billable-client.seamfix.com/billable.js",
    BILLABLE_CSS: "https://billable-client.seamfix.com/billable.css"
  },

  token: {
    SEAMID_TOKEN: 'FLWPUBK-6bf82f3bbee2f21de8030dbc7da1fedc-X',
  },
  
  SEAMID_FLUTTERWAVE_TOKEN: 'FLWPUBK-6bf82f3bbee2f21de8030dbc7da1fedc-X',
  SEAMID_PAYSTACK_TOKEN: 'pk_live_5a1d4ac15988414a9de307378cd4c1d3be70cabf',

  idCardAmount: 5500

};